const ProductTypes = {
  PATIENT_GUIDE: "PATIENT_GUIDE",
  BASIC: "BASIC",
  ADVANCED: "ADVANCED",
  PREMIUM: "PREMIUM",
};

export default ProductTypes;
